import React, { Component } from 'react'

class Content extends Component {
  render () {
    const { shared, children } = this.props
    const { collapsed } = shared.getState()
    const style = collapsed ? {display: 'none', userDrag: 'none', userSelect: 'none'} : {userDrag: 'none', ...this.props.style}
    return (
      <div className="x_content" style={style}>
        { children }
      </div>
    )
  }
}

export default Content
